import { useModal } from '@shared/model/useModal';

/**
 * Модалка предложения слота (преподаватель -> ученик).
 * open({ chatId })
 */
export const useSlotOfferModal = () => useModal('slot-offer');
